var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoMessage } from 'src/ui/components/InfoMessage/InfoMessage';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './AlertItem.module.scss';
export var AlertItem = function (props) {
    var title = props.title, messages = props.messages, severity = props.severity;
    return (_jsxs("div", __assign({ className: styles.AlertItemWrapper }, { children: [_jsxs("div", __assign({ className: styles.AlertItemHeadline }, { children: [_jsx("span", { children: title }), _jsx(Icons, { icon: E_ICONS.ARROW_RIGHT })] })), _jsx(InfoMessage, { severity: severity, messages: messages })] })));
};
